const STORAGE_KEY = 'hixme_admin_settings'

export interface FinanceSettings {
  showTestData: boolean
}

export interface AdminSettings {
  finance: FinanceSettings
}

const defaults: AdminSettings = {
  finance: { showTestData: false },
}

export function getAdminSettings(): AdminSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return defaults
    const parsed = JSON.parse(raw) as Partial<{
      finance: Partial<FinanceSettings>
    }>
    return {
      finance: { ...defaults.finance, ...(parsed.finance ?? {}) },
    }
  } catch {
    return defaults
  }
}

export function setAdminSettings(patch: {
  finance?: Partial<FinanceSettings>
}): void {
  const current = getAdminSettings()
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      finance: { ...current.finance, ...(patch.finance ?? {}) },
    })
  )
}
